import { gray5, mainPoint } from "assets/styleUtils";
import React from "react";
import styles from "./style.module.css";

interface Props {
  nextButtonDisabled?: boolean;
  prevButtonDisabled?: boolean;
  nextButtonText?: string;
  prevButtonEvent?: () => void;
  nextButtonEvent?: () => void;
  style?: React.CSSProperties;
}

export default function BottomButton({
  nextButtonDisabled,
  prevButtonDisabled,
  nextButtonText,
  prevButtonEvent,
  nextButtonEvent,
  style,
}: Props) {
  return (
    <div className={styles.buttonWrap} style={{ ...style }}>
      {prevButtonEvent && (
        <button
          className={styles.prevButton}
          onClick={prevButtonEvent}
          disabled={prevButtonDisabled}
        >
          <svg
            width="7"
            height="18"
            viewBox="0 0 7 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.05017 1L0.939059 9L6.05017 17"
              stroke={prevButtonDisabled ? gray5 : mainPoint}
              strokeWidth="1.33945"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}

      {nextButtonEvent && (
        <button
          className={styles.nextButton}
          disabled={nextButtonDisabled}
          onClick={nextButtonEvent}
        >
          {nextButtonText || "다음"}
        </button>
      )}
    </div>
  );
}
